import type { Location } from 'react-router-dom';
import { readPostSheetState } from '@lib/postSheet/postSheetLocation';

// AIDEV-NOTE: ScrollRestoration's key. Pathname, so bottom nav tabs restore scroll when returning
// to the same path. Exception: location.state.scrollToTop forces a unique key (scroll to top).
// A Post sheet entry takes its background's key, by this same rule: opening the sheet must not
// restore an older position into the feed behind it (a `scrollToTop` feed entry included), and
// closing it restores the feed's own (TECH-197 FE-4).
export function scrollRestorationKey(
  location: Pick<Location, 'pathname' | 'state' | 'key'>,
): string {
  const sheet = readPostSheetState(location);
  if (sheet) return scrollRestorationKey(sheet.background);
  const state = location.state as { scrollToTop?: boolean } | null;
  if (state?.scrollToTop) {
    // Return unique key so ScrollRestoration won't restore previous position
    return `${location.pathname}-${location.key}`;
  }
  return location.pathname;
}
